// AI-CONTEXT: See docs/features/msi-rekenregels-monetarisering.md
//
// De tekst bij wat de rekenregels niet konden doorrekenen. Nodig omdat drie
// schermen (effectkaart, detailpagina's Maatschappelijke waarde en Impact per
// euro) dit tonen en het tabblad Participatieladder per reden een eigen tekst
// heeft: zonder één plek zei elk scherm 'duur of uren onbekend', ook als de
// einddatum vóór de startdatum lag.

const DOSE_MISSING = 'duur of uren onbekend'
const END_BEFORE_START = 'einddatum vóór startdatum'

/**
 * @param {number|null} count - Aantal metingen; null voor de zin 'niemand doorgerekend'
 * @param {Object<string, number>} [reasons] - notAttributedReasons uit de berekening
 * @returns {string}
 */
const notAttributedText = (count, reasons = {}) => {
    const keys = Object.keys(reasons || {}).filter((key) => reasons[key] > 0)
    const endBeforeStart = keys.includes('einde vóór start')
    const missing = keys.some((key) => key !== 'einde vóór start') || !endBeforeStart
    const reason = endBeforeStart && missing
        ? `${DOSE_MISSING}, of ${END_BEFORE_START}`
        : endBeforeStart ? END_BEFORE_START : DOSE_MISSING
    if (count === null) return `Niet doorgerekend: ${reason}`
    return `${count} ${count === 1 ? 'meting' : 'metingen'} niet doorgerekend: ${reason}`
}

export default notAttributedText
